"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initResearchArticles = initResearchArticles;
const firebase_1 = require("./firebase");
const firestore_1 = require("firebase/firestore");
const utils_1 = require("./utils");
const FIRESTORE_COLLECTION = "research_articles";
const PAGE_SIZE = 9;
let lastDocument = null;
function initResearchArticles(container) {
    container.innerHTML = `
      <div class="research-articles">
        <div class="section-heading">Research Articles</div>
        <div class="research-articles-list"></div>
      </div>
    `;
    const researchArticles = container.querySelector(".research-articles");
    const sectionHeading = container.querySelector(".section-heading");
    const researchArticlesList = container.querySelector(".research-articles-list");
    if (!researchArticles || !sectionHeading || !researchArticlesList)
        return;
    loadResearchArticles(container);
    let isLoading = false;
    let hasMoreData = true;
    const handleScroll = () => __awaiter(this, void 0, void 0, function* () {
        const rect = researchArticlesList.getBoundingClientRect();
        const isNearBottom = rect.bottom <= window.innerHeight + 100;
        if (!isLoading && hasMoreData && isNearBottom) {
            isLoading = true;
            try {
                const hasMore = yield loadResearchArticles(container);
                hasMoreData = hasMore;
            }
            catch (error) {
                console.error("Error loading research articles:", error);
            }
            finally {
                isLoading = false;
            }
        }
        // const articlesRect = researchArticles.getBoundingClientRect();
        // const isInViewport = articlesRect.top <= 0 && articlesRect.bottom > 0;
        // if (isInViewport) {
        //     sectionHeading.classList.add("sticky");
        // } else {
        //     sectionHeading.classList.remove("sticky");
        // }
    });
    const throttle = (func, limit) => {
        let lastCall = 0;
        return (...args) => {
            const now = Date.now();
            if (now - lastCall >= limit) {
                lastCall = now;
                func(...args);
            }
        };
    };
    window.addEventListener("scroll", throttle(handleScroll, 200));
}
function loadResearchArticles(container) {
    return __awaiter(this, void 0, void 0, function* () {
        const researchArticlesList = container.querySelector(".research-articles-list");
        if (!researchArticlesList)
            return false;
        try {
            const db = yield (0, firebase_1.getFirestoreInstance)();
            let researchArticlesQuery = (0, firestore_1.query)((0, firestore_1.collection)(db, FIRESTORE_COLLECTION), (0, firestore_1.orderBy)("date", "desc"), (0, firestore_1.limit)(PAGE_SIZE));
            if (lastDocument) {
                researchArticlesQuery = (0, firestore_1.query)(researchArticlesQuery, (0, firestore_1.startAfter)(lastDocument));
            }
            const querySnapshot = yield (0, firestore_1.getDocs)(researchArticlesQuery);
            if (querySnapshot.empty) {
                console.log("No more research articles to load");
                return false;
            }
            querySnapshot.forEach((doc) => {
                var _a, _b;
                const researchArticleData = doc.data();
                console.log("researchArticleData - ", researchArticleData);
                const researchArticleElement = document.createElement("div");
                researchArticleElement.classList.add("research-article");
                researchArticleElement.innerHTML = `
                <div class="thumbnail" style="background-image: url('${researchArticleData.img_link}');"></div>
                <div class="date">${(0, utils_1.formatDate)(researchArticleData.date)}</div>
                <div class="title">${(_a = researchArticleData.headline) === null || _a === void 0 ? void 0 : _a.trim()}</div>
                <div class="description">${(_b = researchArticleData.description) === null || _b === void 0 ? void 0 : _b.trim()}</div>
                <a class="read-more-link" href="${researchArticleData.source}" target="_blank">Read More</a>
            `;
                researchArticlesList.appendChild(researchArticleElement);
            });
            lastDocument = querySnapshot.docs[querySnapshot.docs.length - 1];
            return true;
        }
        catch (error) {
            console.error("Error loading research articles:", error);
            return false;
        }
    });
}
